export const stateAbbvToName = {
  'AL':'Alabama',
  'AK':'Alaska',
  'AS':'American Samoa',
  'AZ':'Arizona',
  'AR':'Arkansas',
  'AA':'Armed Forces Americas',
  'AE':'Armed Forces Europe',
  'AP':'Armed Forces Pacific',
  'CA':'California',
  'CO':'Colorado',
  'CT':'Connecticut',
  'DE':'Delaware',
  'DC':'District Of Columbia',
  'FL':'Florida',
  'GA':'Georgia',
  'GU':'Guam',
  'HI':'Hawaii',
  'ID':'Idaho',
  'IL':'Illinois',
  'IN':'Indiana',
  'IA':'Iowa',
  'KS':'Kansas',
  'KY':'Kentucky',
  'LA':'Louisiana',
  'ME':'Maine',
  'MH':'Marshall Islands',
  'MD':'Maryland',
  'MA':'Massachusetts',
  'MI':'Michigan',
  'MN':'Minnesota',
  'MS':'Mississippi',
  'MO':'Missouri',
  'MT':'Montana',
  'NE':'Nebraska',
  'NV':'Nevada',
  'NH':'New Hampshire',
  'NJ':'New Jersey',
  'NM':'New Mexico',
  'NY':'New York',
  'NC':'North Carolina',
  'ND':'North Dakota',
  'NP':'Northern Mariana Islands',
  'OH':'Ohio',
  'OK':'Oklahoma',
  'OR':'Oregon',
  'PA':'Pennsylvania',
  'PR':'Puerto Rico',
  'RI':'Rhode Island',
  'SC':'South Carolina',
  'SD':'South Dakota',
  'TN':'Tennessee',
  'TX':'Texas',
  'VI':'US Virgin Islands',
  'UT':'Utah',
  'VT':'Vermont',
  'VA':'Virginia',
  'WA':'Washington',
  'WV':'West Virginia',
  'WI':'Wisconsin',
  'WY':'Wyoming'
}

export const stateNameToAbbv = {
  'alabama':'AL',
  'alaska':'AK',
  'american samoa':'AS',
  'arizona':'AZ',
  'arkansas':'AR',
  'armed forces americas':'AA',
  'armed forces europe':'AE',
  'armed forces pacific':'AP',
  'california':'CA',
  'colorado':'CO',
  'connecticut':'CT',
  'delaware':'DE',
  'district of columbia':'DC',
  'florida':'FL',
  'georgia':'GA',
  'guam':'GU',
  'hawaii':'HI',
  'idaho':'ID',
  'illinois':'IL',
  'indiana':'IN',
  'iowa':'IA',
  'kansas':'KS',
  'kentucky':'KY',
  'louisiana':'LA',
  'maine':'ME',
  'marshall islands':'MH',
  'maryland':'MD',
  'massachusetts':'MA',
  'michigan':'MI',
  'minnesota':'MN',
  'mississippi':'MS',
  'missouri':'MO',
  'montana':'MT',
  'nebraska':'NE',
  'nevada':'NV',
  'new hampshire':'NH',
  'new jersey':'NJ',
  'new mexico':'NM',
  'new york':'NY',
  'north carolina':'NC',
  'north dakota':'ND',
  'northern mariana islands':'NP',
  'ohio':'OH',
  'oklahoma':'OK',
  'oregon':'OR',
  'pennsylvania':'PA',
  'puerto rico':'PR',
  'rhode island':'RI',
  'south carolina':'SC',
  'south dakota':'SD',
  'tennessee':'TN',
  'texas':'TX',
  'us virgin islands':'VI',
  'utah':'UT',
  'vermont':'VT',
  'virginia':'VA',
  'washington':'WA',
  'west virginia':'WV',
  'wisconsin':'WI',
  'wyoming':'WY'
}
